import { render, staticRenderFns } from "./CollegeSituation.vue?vue&type=template&id=6b5b4e5b&scoped=true&"
import script from "./CollegeSituation.vue?vue&type=script&lang=js&"
export * from "./CollegeSituation.vue?vue&type=script&lang=js&"
import style0 from "./CollegeSituation.vue?vue&type=style&index=0&id=6b5b4e5b&scoped=true&lang=less&"
import style1 from "./CollegeSituation.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b4e5b",
  null
  
)

export default component.exports